import { render } from "./TreeUpsert.vue?vue&type=template&id=6b799b9b"
import script from "./TreeUpsert.vue?vue&type=script&lang=js"
export * from "./TreeUpsert.vue?vue&type=script&lang=js"

import exportComponent from "/home/jhg/tagforest/tagforest-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__